import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onLobbiesUpdate } from '../lib/firebase/collections';
import type { Lobby as LobbyType } from '../types/game'; 
import LobbyList from './LobbyList';
import LobbyCreation from './LobbyCreation';

const Lobby = () => {
  const [lobbies, setLobbies] = useState<LobbyType[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onLobbiesUpdate((updatedLobbies: LobbyType[]) => {
      setLobbies(updatedLobbies);
      setLoading(false);
    }, (error: Error) => {
      console.error("Failed to fetch lobbies:", error);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const handleCreateLobby = (lobbyId: string) => {
      navigate(`/lobby/${lobbyId}`);
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-900 text-white">
        <p className="text-xl">Lade Lobbys...</p>
      </div>
    );
    }

  return (
    <div className="container mx-auto p-4 bg-gray-900 text-white min-h-screen">
      <h1 className="text-4xl font-bold text-center my-8">Verfügbare Lobbys</h1>
      <LobbyCreation onCreateLobby={handleCreateLobby} categories={[]} />
      <LobbyList lobbies={lobbies} />
    </div>
  );
};

export default Lobby; 